"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.associationGroups = exports.associationGroup = void 0;
var associationGroup = {
    id: 1,
    metadataAssociations: [
        {
            id: 10,
            required: true,
            metadataDefinition: {
                id: 13,
                beanNotation: "context.organizationCode",
                metadataSourceId: 4,
                metadataSource: {
                    id: 4,
                    microserviceServiceName: "workflowexecutioncontext",
                    method: null,
                    metadataAssociations: null
                },
                dataType: null,
                metadataDefinitionName: "Tenant",
                metadataVarName: "tenant",
                metadataGroup: "organization",
                predicateField: null,
                automatedFetch: true,
                predicateValue: null
            },
            metadataDefinitionId: 13,
            associationGroupId: 1
        },
        {
            id: 11,
            required: true,
            metadataDefinition: {
                id: 16,
                beanNotation: null,
                metadataSourceId: null,
                metadataSource: null,
                dataType: null,
                metadataDefinitionName: "Notes",
                metadataVarName: "notes",
                metadataGroup: null,
                predicateField: null,
                automatedFetch: false,
                predicateValue: null
            },
            metadataDefinitionId: 16,
            associationGroupId: 1
        },
        {
            id: 9,
            required: true,
            metadataDefinition: {
                id: 15,
                beanNotation: "root.observationRequest.order.dateOfService",
                metadataSourceId: 6,
                metadataSource: {
                    id: 6,
                    microserviceServiceName: "orderService",
                    method: null,
                    metadataAssociations: null
                },
                dataType: "DATE",
                metadataDefinitionName: "Date of Service",
                metadataVarName: "dateOfService",
                metadataGroup: null,
                predicateField: null,
                automatedFetch: true,
                predicateValue: null
            },
            metadataDefinitionId: 15,
            associationGroupId: 1
        },
        {
            id: 12,
            required: true,
            metadataDefinition: {
                id: 14,
                beanNotation: "root.billingArea",
                metadataSourceId: 5,
                metadataSource: {
                    id: 5,
                    microserviceServiceName: "encounterService",
                    method: null,
                    metadataAssociations: null
                },
                dataType: null,
                metadataDefinitionName: "Billing Area",
                metadataVarName: "billingArea",
                metadataGroup: null,
                predicateField: null,
                automatedFetch: true,
                predicateValue: null
            },
            metadataDefinitionId: 14,
            associationGroupId: 1
        }
    ],
    associationGroupName: "Radiology Group"
};
exports.associationGroup = associationGroup;
var associationGroups = [associationGroup];
exports.associationGroups = associationGroups;
//# sourceMappingURL=metadata-association.js.map